import { render, staticRenderFns } from "./FlipBookView.vue?vue&type=template&id=7bda7e2e&scoped=true&"
import script from "./FlipBookView.vue?vue&type=script&lang=js&"
export * from "./FlipBookView.vue?vue&type=script&lang=js&"
import style0 from "./FlipBookView.vue?vue&type=style&index=0&id=7bda7e2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bda7e2e",
  null
  
)

export default component.exports